import { APIError } from '../../../utils/api'
import { DmsConnectionErrorType } from '../enums/dmsConnectionErrorType'

export const isFolderNotFoundError = (error: unknown): boolean =>
  error instanceof APIError && error.body?.type === DmsConnectionErrorType.FolderNotFound
